import { useCallback, useRef, useState } from 'react'
import { useNavigate } from "react-router";
import MaterialTable, { Options, Query } from '@material-table/core';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import { urls, route } from '../route';
import { deleteApiWorkout_typeWorkouttypeid } from '../services/workout.type';
import { WorkoutType } from '../models/WorkoutType';
import { confirmAndDelete } from '../utils';
import { getApiWorkout_typeList } from '../services/workout.type';
export const ProgramsTypesList = () => {
    const history = useNavigate();
    const ref = useRef<any>();
    const [pagination,] = useState<Options<WorkoutType>>({
        actionsColumnIndex: -1,
        selection: true,
        maxColumnSort: 1,
        pageSize: 10,
    });

    const dataLoader = useCallback(async (q: Query<WorkoutType>) => {
        const pageIndex = q.page ?? 0
        const pageSize = q.pageSize ?? 10
        const skip = pageIndex * pageSize

        const rawSortBy = q.orderBy?.field
        const sortBy = Array.isArray(rawSortBy) ? rawSortBy[0] : rawSortBy
        const sortOrder = q.orderDirection

        const search = (q.search ?? "").trim()
        const res = await getApiWorkout_typeList({
            kind: "Program",
            skip,
            limit: pageSize,
            search,
            sortBy,
            sortOrder,
        })

        const totalCount =
            typeof res.total === "number"
                ? res.total
                : pageIndex * pageSize + res.items.length
        const allowedMaxPage = Math.max(0, Math.ceil(totalCount / pageSize) - 1)
        const safePage = Math.min(pageIndex, allowedMaxPage)

        return { data: res.items, page: safePage, totalCount }
    }, [])
    return <div>
        <MaterialTable<WorkoutType>
            title="Programs Types"
            options={pagination}
            tableRef={ref}
            columns={[
                { title: "Id", field: "id", cellStyle: { width: "5%" } },
                { title: "Name", field: "name", width: "90%" },
                {
                    title: 'Tools',
                    render: (e) => (<>
                        <IconButton onClick={() => history(`/app/programs-type/edit/${e.id}`)} style={{ float: "right" }}><Icon>edit</Icon></IconButton>
                        <IconButton onClick={confirmAndDelete(e, deleteApiWorkout_typeWorkouttypeid, ref)} style={{ float: "right" }}><Icon>delete</Icon></IconButton>
                    </>)
                }
            ]}
            data={dataLoader}
            actions={[{
                icon: "delete",
                tooltip: "Delete",
                onClick: async (event, data) => {
                    const confirmation = window.confirm("Are you sure you want to delete the selected items?")
                    if (confirmation && Array.isArray(data)) {
                        for (const i of data) {
                            await deleteApiWorkout_typeWorkouttypeid(i.id);
                        }
                        if (ref.current) {
                            ref.current.onQueryChange();
                        }
                    }
                }
            }, {
                icon: "add",
                tooltip: "Add New",
                isFreeAction: true,
                onClick: () => history(route(urls.programsTypeAdd)),
            }]}
        />
    </div>
}